// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Header.css — redesign of the dashboard top bar (centered search + bell).
 * Loaded by Header.jsx AFTER index.css, so it wins at equal specificity.
 * Reuses existing tokens; only adds the search box, the notification popover,
 * and the 3-zone (left / center / right) layout.
 */

.dashboard-header {
  gap: 16px;
}

/* Left zone no longer grows — the search takes the slack. */
.dashboard-header .header-left {
  flex: 0 0 auto;
}

/* On desktop the sidebar owns navigation, so the hamburger is hidden there
   (kept available ≤991px by nav.css). Don't force it here — leave to nav.css. */

/* ─── Centered search ───────────────────────────────────────────────── */
.header-search {
  position: relative;
  flex: 1 1 auto;
  max-width: 560px;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
  padding: 0 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  transition: border-color 0.15s, box-shadow 0.15s;
}

.header-search:focus-within {
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.12);
  background: var(--bg-primary);
}

.header-search-icon {
  color: var(--text-muted);
  flex-shrink: 0;
}

.header-search input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  outline: none;
  font-size: 14px;
  color: var(--text-primary);
  font-family: var(--iv-sans);
}

.header-search input::placeholder {
  color: var(--text-muted);
}

[data-theme="dark"] .header-search input::placeholder {
  color: var(--text-secondary);
}

.header-search-kbd {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 2px 7px;
  letter-spacing: 0.5px;
}

/* ─── Module suggestions ────────────────────────────────────────────── */
.header-search-results {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  z-index: 100;
  padding: 6px;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.16);
  max-height: 340px;
  overflow-y: auto;
}

.header-search-result {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border: none;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--text-primary);
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  font-family: var(--iv-sans);
}

.header-search-result.active {
  background: var(--bg-tertiary);
}

.header-search-result-icon {
  flex-shrink: 0;
  color: var(--text-muted);
}

.header-search-result.active .header-search-result-icon {
  color: var(--accent-primary);
}

.header-search-result-label {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-search-result-group {
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--text-muted);
}

.header-search-fallback {
  color: var(--text-secondary);
  font-size: 13px;
}

.header-search-results .header-search-fallback:not(:first-child) {
  margin-top: 4px;
  border-top: 1px solid var(--border-color);
  border-radius: 0 0 var(--radius-sm, 6px) var(--radius-sm, 6px);
  padding-top: 11px;
}

.header-search-empty {
  padding: 12px 10px;
  font-size: 13px;
  color: var(--text-muted);
}

/* ─── Notifications popover ─────────────────────────────────────────── */
.notif-dropdown {
  position: relative;
}

.notification-btn {
  position: relative;
}

/* Unread badge on the bell. */
.notif-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: var(--danger, #ef4444);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  box-shadow: 0 0 0 2px var(--bg-primary);
}

.notif-menu {
  width: 360px;
  max-width: calc(100vw - 24px);
  padding: 0;
  overflow: hidden;

  /* An unread row needs a tint that is NOT --bg-secondary: that value is what
     :hover uses, so an unread row previously looked identical to a hovered read
     one. A violet wash reads as "flagged" against the grey-blue neutrals. */
  --notif-unread-wash: rgba(139, 92, 246, 0.07);
  --notif-unread-wash-hover: rgba(139, 92, 246, 0.12);
}

[data-theme="dark"] .notif-menu {
  --notif-unread-wash: rgba(139, 92, 246, 0.18);
  --notif-unread-wash-hover: rgba(139, 92, 246, 0.26);
}

/* ─── Popover header ─────────────────────────────────────────────────── */
.notif-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border-color);
}

.notif-head-title {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

.notif-head-title strong {
  font-size: 14px;
  color: var(--text-primary);
}

.notif-head-count {
  font-size: 11px;
  font-weight: 600;
  color: var(--accent-primary);
  white-space: nowrap;
}

.notif-head-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.notif-filter {
  padding: 4px 9px;
  border: 1px solid var(--border-color);
  border-radius: 999px;
  background: transparent;
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}

.notif-filter:hover {
  color: var(--text-primary);
  background: var(--bg-tertiary);
}

.notif-filter.active {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.notif-head-tool {
  width: 26px;
  height: 26px;
}

.notif-head-tool:hover:not(:disabled) {
  background: var(--bg-tertiary);
  color: var(--accent-primary);
}

/* Clear all removes rows, so it reads as destructive on hover. */
.notif-head-tool.danger:hover:not(:disabled) {
  color: var(--danger, #ef4444);
}

.notif-head-tool:disabled {
  opacity: 0.5;
  cursor: default;
}

/* ─── List ───────────────────────────────────────────────────────────── */
.notif-list {
  max-height: 400px;
  overflow-y: auto;
}

.notif-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 16px;
  font-size: 13px;
  color: var(--text-muted);
}

.notif-retry {
  border: none;
  background: transparent;
  color: var(--accent-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.notif-item {
  position: relative;
  display: flex;
  align-items: stretch;
  border-bottom: 1px solid var(--border-color);
}

.notif-item:last-child {
  border-bottom: none;
}

.notif-item:hover {
  background: var(--bg-secondary);
}

/* Unread rows: accent wash + severity-coloured left rail + a dot. Three cues,
   because the row also has to read as unread at a glance in a scrolling list. */
.notif-item.unread {
  background: var(--notif-unread-wash);
}

.notif-item.unread:hover {
  background: var(--notif-unread-wash-hover);
}

.notif-item.unread::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: var(--accent-primary);
}

.notif-item.unread.sev-success::before {
  background: var(--success, #10b981);
}

.notif-item.unread.sev-warning::before {
  background: var(--warning, #f59e0b);
}

.notif-item.unread.sev-critical::before {
  background: var(--danger, #ef4444);
}

.notif-item-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 6px 12px 14px;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font-family: var(--iv-sans);
}

.notif-item-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--bg-tertiary);
  color: var(--text-muted);
}

.sev-success .notif-item-icon {
  color: var(--success, #10b981);
}

.sev-warning .notif-item-icon {
  color: var(--warning, #f59e0b);
}

.sev-critical .notif-item-icon {
  color: var(--danger, #ef4444);
}

.notif-item-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.notif-item-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
  line-height: 1.35;
}

/* Already-read rows recede; unread ones carry full weight and colour. */
.notif-item.unread .notif-item-title {
  font-weight: 700;
  color: var(--text-primary);
}

.notif-item.unread .notif-item-body {
  color: var(--text-secondary);
}

.notif-item-body {
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.notif-item-time {
  margin-top: 2px;
  font-size: 11px;
  color: var(--text-muted);
}

.notif-item-dot {
  flex-shrink: 0;
  width: 7px;
  height: 7px;
  margin-top: 6px;
  border-radius: 50%;
  background: var(--accent-primary);
}

/* Row tools stay visible but quiet, so the read/unread toggle is discoverable
   without hunting for it, and come up to full contrast on hover or focus. */
.notif-item-tools {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
  padding: 8px 8px 8px 0;
  opacity: 0.45;
  transition: opacity 0.12s ease;
}

.notif-item:hover .notif-item-tools,
.notif-item:focus-within .notif-item-tools {
  opacity: 1;
}

.notif-tool {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border: none;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
}

.notif-tool:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.notif-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 6px;
  padding: 36px 24px;
}

.notif-empty svg {
  color: var(--text-muted);
  margin-bottom: 4px;
}

.notif-empty p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.notif-empty span {
  font-size: 12px;
  color: var(--text-muted);
  line-height: 1.4;
}

/* ─── Responsive ────────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .notif-menu {
    /* width: calc(100vw - 24px); */
  }
  /* Touch devices have no hover at all, so run the tools at full contrast. */
  .notif-item-tools {
    opacity: 1;
  }
  .header-search {
    max-width: none;
  }
  .header-search-kbd {
    display: none;
  }
}

@media (max-width: 576px) {
  .header-search {
    display: none;
  }
}
@media (max-width: 480px) {
  .notif-menu{
     width:300px;
     left: -190px;
  }
}

/* ─── Sign-out confirmation ───────────────────────────────────────────────────
 *
 * Portalled to <body> from Header.jsx, so this owns its own centering rather
 * than inheriting anything from the header.
 *
 * Colours come from the design-system tokens (--brand-600 / --accent), so the
 * dialog tracks the MaxelPay button colour instead of hardcoding a violet that
 * would drift when the brand ramp changes.
 */
.logout-confirm-backdrop {
  position: fixed;
  inset: 0;
  /* Above everything the dashboard can have open at the time. The row-action
     dropdowns (.action-dropdown-menu) and the table overlays already sit at
     9999, so a lower value here would let them punch through the blur. */
  z-index: 10000;

  /* Flex centering on the backdrop, so the card needs no transform trick and
     stays centred while it grows with its own content. */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  /* The blur is what lifts the card off the page. Slightly darker than the
     standard .modal-overlay because blur alone washes out contrast. */
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px); /* Safari, incl. iOS */

  animation: logout-confirm-fade 0.16s ease-out;
}

/* backdrop-filter is unsupported in Firefox unless the user enables it. Deepen
   the scrim there so the card is still clearly the focus rather than floating
   over a fully legible page. */
@supports not ((backdrop-filter: blur(6px)) or (-webkit-backdrop-filter: blur(6px))) {
  .logout-confirm-backdrop {
    background: rgba(15, 23, 42, 0.72);
  }
}

.logout-confirm-card {
  width: 100%;
  max-width: 400px;
  padding: 32px;
  text-align: center;

  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg, 16px);

  /* Depth plus a brand-tinted rim, so the card reads as MaxelPay's rather than
     as a generic system dialog. */
  box-shadow:
    0 24px 48px rgba(15, 23, 42, 0.28),
    0 0 0 1px rgba(109, 93, 246, 0.14);

  animation: logout-confirm-rise 0.18s ease-out;
}

.logout-confirm-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  /* Brand tint, not the amber/red of a destructive action: signing out loses
     no data, so warning colours would overstate it. */
  background: rgba(109, 93, 246, 0.12);
  color: var(--accent, #6d5df6);
}

.logout-confirm-card h3 {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
}

.logout-confirm-card p {
  margin: 0 0 24px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary);
}

.logout-confirm-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.logout-confirm-actions button {
  flex: 1 1;
  padding: 12px 20px;
  border-radius: var(--radius-md, 10px);
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}

.logout-confirm-cancel {
  background: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
}

.logout-confirm-cancel:hover {
  background: var(--bg-secondary);
}

/* The MaxelPay button: same violet gradient as .btn-primary. */
.logout-confirm-submit {
  background: linear-gradient(135deg, #8b5cf6, #7c3aed);
  color: #ffffff;
  border: none;
}

.logout-confirm-submit:hover {
  background: linear-gradient(135deg, #7c3aed, #6d28d9);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);
}

.logout-confirm-actions button:focus-visible {
  outline: 2px solid var(--accent, #6d5df6);
  outline-offset: 2px;
}

@keyframes logout-confirm-fade {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes logout-confirm-rise {
  from { opacity: 0; transform: translateY(8px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

/* Respect a reduced-motion preference: show the dialog, skip the movement. */
@media (prefers-reduced-motion: reduce) {
  .logout-confirm-backdrop,
  .logout-confirm-card {
    animation: none;
  }
  .logout-confirm-submit:hover {
    transform: none;
  }
}

@media (max-width: 480px) {
  .logout-confirm-card {
    padding: 24px 20px;
  }
  .logout-confirm-actions {
    flex-direction: column-reverse; /* primary action nearest the thumb */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Header.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,SAAS;AACX;;AAEA,4DAA4D;AAC5D;EACE,cAAc;AAChB;;AAEA;gFACgF;;AAEhF,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,gDAAgD;AAClD;;AAEA;EACE,mCAAmC;EACnC,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;EAC/B,2CAA2C;EAC3C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,8DAA8D;EAC9D,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,UAAU;EACV,gBAAgB;;EAEhB;;4EAE0E;EAC1E,6CAA6C;EAC7C,mDAAmD;AACrD;;AAEA;EACE,6CAA6C;EAC7C,mDAAmD;AACrD;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA,iEAAiE;AACjE;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,2EAA2E;AAC3E;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;gFACgF;AAChF;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;4EAC4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE;IACE,+BAA+B;EACjC;EACA,2EAA2E;EAC3E;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;KACG,WAAW;KACX,YAAY;EACf;AACF;;AAEA;;;;;;;;EAQE;AACF;EACE,eAAe;EACf,QAAQ;EACR;;yEAEuE;EACvE,cAAc;;EAEd;yDACuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;;EAEb;sEACoE;EACpE,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC,EAAE,sBAAsB;;EAE1D,6CAA6C;AAC/C;;AAEA;;+BAE+B;AAC/B;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;;EAElB,6BAA6B;EAC7B,qCAAqC;EACrC,qCAAqC;;EAErC;kCACgC;EAChC;;sCAEoC;;EAEpC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB;sDACoD;EACpD,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,+DAA+D;AAC/D;EACE,qDAAqD;EACrD,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA,6EAA6E;AAC7E;EACE;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,8BAA8B,EAAE,qCAAqC;EACvE;AACF","sourcesContent":["/*\n * Header.css — redesign of the dashboard top bar (centered search + bell).\n * Loaded by Header.jsx AFTER index.css, so it wins at equal specificity.\n * Reuses existing tokens; only adds the search box, the notification popover,\n * and the 3-zone (left / center / right) layout.\n */\n\n.dashboard-header {\n  gap: 16px;\n}\n\n/* Left zone no longer grows — the search takes the slack. */\n.dashboard-header .header-left {\n  flex: 0 0 auto;\n}\n\n/* On desktop the sidebar owns navigation, so the hamburger is hidden there\n   (kept available ≤991px by nav.css). Don't force it here — leave to nav.css. */\n\n/* ─── Centered search ───────────────────────────────────────────────── */\n.header-search {\n  position: relative;\n  flex: 1 1 auto;\n  max-width: 560px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height: 40px;\n  padding: 0 12px;\n  background: var(--bg-secondary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.header-search:focus-within {\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.12);\n  background: var(--bg-primary);\n}\n\n.header-search-icon {\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n\n.header-search input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 14px;\n  color: var(--text-primary);\n  font-family: var(--iv-sans);\n}\n\n.header-search input::placeholder {\n  color: var(--text-muted);\n}\n\n[data-theme=\"dark\"] .header-search input::placeholder {\n  color: var(--text-secondary);\n}\n\n.header-search-kbd {\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-muted);\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  padding: 2px 7px;\n  letter-spacing: 0.5px;\n}\n\n/* ─── Module suggestions ────────────────────────────────────────────── */\n.header-search-results {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  right: 0;\n  z-index: 100;\n  padding: 6px;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.16);\n  max-height: 340px;\n  overflow-y: auto;\n}\n\n.header-search-result {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 10px;\n  border: none;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--text-primary);\n  font-size: 14px;\n  text-align: left;\n  cursor: pointer;\n  font-family: var(--iv-sans);\n}\n\n.header-search-result.active {\n  background: var(--bg-tertiary);\n}\n\n.header-search-result-icon {\n  flex-shrink: 0;\n  color: var(--text-muted);\n}\n\n.header-search-result.active .header-search-result-icon {\n  color: var(--accent-primary);\n}\n\n.header-search-result-label {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.header-search-result-group {\n  flex-shrink: 0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n.header-search-fallback {\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n\n.header-search-results .header-search-fallback:not(:first-child) {\n  margin-top: 4px;\n  border-top: 1px solid var(--border-color);\n  border-radius: 0 0 var(--radius-sm, 6px) var(--radius-sm, 6px);\n  padding-top: 11px;\n}\n\n.header-search-empty {\n  padding: 12px 10px;\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n/* ─── Notifications popover ─────────────────────────────────────────── */\n.notif-dropdown {\n  position: relative;\n}\n\n.notification-btn {\n  position: relative;\n}\n\n/* Unread badge on the bell. */\n.notif-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  min-width: 16px;\n  height: 16px;\n  padding: 0 4px;\n  border-radius: 999px;\n  background: var(--danger, #ef4444);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 16px;\n  text-align: center;\n  box-shadow: 0 0 0 2px var(--bg-primary);\n}\n\n.notif-menu {\n  width: 360px;\n  max-width: calc(100vw - 24px);\n  padding: 0;\n  overflow: hidden;\n\n  /* An unread row needs a tint that is NOT --bg-secondary: that value is what\n     :hover uses, so an unread row previously looked identical to a hovered read\n     one. A violet wash reads as \"flagged\" against the grey-blue neutrals. */\n  --notif-unread-wash: rgba(139, 92, 246, 0.07);\n  --notif-unread-wash-hover: rgba(139, 92, 246, 0.12);\n}\n\n[data-theme=\"dark\"] .notif-menu {\n  --notif-unread-wash: rgba(139, 92, 246, 0.18);\n  --notif-unread-wash-hover: rgba(139, 92, 246, 0.26);\n}\n\n/* ─── Popover header ─────────────────────────────────────────────────── */\n.notif-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.notif-head-title {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  min-width: 0;\n}\n\n.notif-head-title strong {\n  font-size: 14px;\n  color: var(--text-primary);\n}\n\n.notif-head-count {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--accent-primary);\n  white-space: nowrap;\n}\n\n.notif-head-actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.notif-filter {\n  padding: 4px 9px;\n  border: 1px solid var(--border-color);\n  border-radius: 999px;\n  background: transparent;\n  color: var(--text-secondary);\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.notif-filter:hover {\n  color: var(--text-primary);\n  background: var(--bg-tertiary);\n}\n\n.notif-filter.active {\n  border-color: var(--accent-primary);\n  color: var(--accent-primary);\n}\n\n.notif-head-tool {\n  width: 26px;\n  height: 26px;\n}\n\n.notif-head-tool:hover:not(:disabled) {\n  background: var(--bg-tertiary);\n  color: var(--accent-primary);\n}\n\n/* Clear all removes rows, so it reads as destructive on hover. */\n.notif-head-tool.danger:hover:not(:disabled) {\n  color: var(--danger, #ef4444);\n}\n\n.notif-head-tool:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* ─── List ───────────────────────────────────────────────────────────── */\n.notif-list {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.notif-state {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 24px 16px;\n  font-size: 13px;\n  color: var(--text-muted);\n}\n\n.notif-retry {\n  border: none;\n  background: transparent;\n  color: var(--accent-primary);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.notif-item {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.notif-item:last-child {\n  border-bottom: none;\n}\n\n.notif-item:hover {\n  background: var(--bg-secondary);\n}\n\n/* Unread rows: accent wash + severity-coloured left rail + a dot. Three cues,\n   because the row also has to read as unread at a glance in a scrolling list. */\n.notif-item.unread {\n  background: var(--notif-unread-wash);\n}\n\n.notif-item.unread:hover {\n  background: var(--notif-unread-wash-hover);\n}\n\n.notif-item.unread::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  background: var(--accent-primary);\n}\n\n.notif-item.unread.sev-success::before {\n  background: var(--success, #10b981);\n}\n\n.notif-item.unread.sev-warning::before {\n  background: var(--warning, #f59e0b);\n}\n\n.notif-item.unread.sev-critical::before {\n  background: var(--danger, #ef4444);\n}\n\n.notif-item-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 6px 12px 14px;\n  border: none;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  font-family: var(--iv-sans);\n}\n\n.notif-item-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--bg-tertiary);\n  color: var(--text-muted);\n}\n\n.sev-success .notif-item-icon {\n  color: var(--success, #10b981);\n}\n\n.sev-warning .notif-item-icon {\n  color: var(--warning, #f59e0b);\n}\n\n.sev-critical .notif-item-icon {\n  color: var(--danger, #ef4444);\n}\n\n.notif-item-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.notif-item-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  line-height: 1.35;\n}\n\n/* Already-read rows recede; unread ones carry full weight and colour. */\n.notif-item.unread .notif-item-title {\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.notif-item.unread .notif-item-body {\n  color: var(--text-secondary);\n}\n\n.notif-item-body {\n  font-size: 12px;\n  color: var(--text-secondary);\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.notif-item-time {\n  margin-top: 2px;\n  font-size: 11px;\n  color: var(--text-muted);\n}\n\n.notif-item-dot {\n  flex-shrink: 0;\n  width: 7px;\n  height: 7px;\n  margin-top: 6px;\n  border-radius: 50%;\n  background: var(--accent-primary);\n}\n\n/* Row tools stay visible but quiet, so the read/unread toggle is discoverable\n   without hunting for it, and come up to full contrast on hover or focus. */\n.notif-item-tools {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 2px;\n  padding: 8px 8px 8px 0;\n  opacity: 0.45;\n  transition: opacity 0.12s ease;\n}\n\n.notif-item:hover .notif-item-tools,\n.notif-item:focus-within .notif-item-tools {\n  opacity: 1;\n}\n\n.notif-tool {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border: none;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n}\n\n.notif-tool:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.notif-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 6px;\n  padding: 36px 24px;\n}\n\n.notif-empty svg {\n  color: var(--text-muted);\n  margin-bottom: 4px;\n}\n\n.notif-empty p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.notif-empty span {\n  font-size: 12px;\n  color: var(--text-muted);\n  line-height: 1.4;\n}\n\n/* ─── Responsive ────────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n  .notif-menu {\n    /* width: calc(100vw - 24px); */\n  }\n  /* Touch devices have no hover at all, so run the tools at full contrast. */\n  .notif-item-tools {\n    opacity: 1;\n  }\n  .header-search {\n    max-width: none;\n  }\n  .header-search-kbd {\n    display: none;\n  }\n}\n\n@media (max-width: 576px) {\n  .header-search {\n    display: none;\n  }\n}\n@media (max-width: 480px) {\n  .notif-menu{\n     width:300px;\n     left: -190px;\n  }\n}\n\n/* ─── Sign-out confirmation ───────────────────────────────────────────────────\n *\n * Portalled to <body> from Header.jsx, so this owns its own centering rather\n * than inheriting anything from the header.\n *\n * Colours come from the design-system tokens (--brand-600 / --accent), so the\n * dialog tracks the MaxelPay button colour instead of hardcoding a violet that\n * would drift when the brand ramp changes.\n */\n.logout-confirm-backdrop {\n  position: fixed;\n  inset: 0;\n  /* Above everything the dashboard can have open at the time. The row-action\n     dropdowns (.action-dropdown-menu) and the table overlays already sit at\n     9999, so a lower value here would let them punch through the blur. */\n  z-index: 10000;\n\n  /* Flex centering on the backdrop, so the card needs no transform trick and\n     stays centred while it grows with its own content. */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n\n  /* The blur is what lifts the card off the page. Slightly darker than the\n     standard .modal-overlay because blur alone washes out contrast. */\n  background: rgba(15, 23, 42, 0.55);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px); /* Safari, incl. iOS */\n\n  animation: logout-confirm-fade 0.16s ease-out;\n}\n\n/* backdrop-filter is unsupported in Firefox unless the user enables it. Deepen\n   the scrim there so the card is still clearly the focus rather than floating\n   over a fully legible page. */\n@supports not ((backdrop-filter: blur(6px)) or (-webkit-backdrop-filter: blur(6px))) {\n  .logout-confirm-backdrop {\n    background: rgba(15, 23, 42, 0.72);\n  }\n}\n\n.logout-confirm-card {\n  width: 100%;\n  max-width: 400px;\n  padding: 32px;\n  text-align: center;\n\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg, 16px);\n\n  /* Depth plus a brand-tinted rim, so the card reads as MaxelPay's rather than\n     as a generic system dialog. */\n  box-shadow:\n    0 24px 48px rgba(15, 23, 42, 0.28),\n    0 0 0 1px rgba(109, 93, 246, 0.14);\n\n  animation: logout-confirm-rise 0.18s ease-out;\n}\n\n.logout-confirm-icon {\n  width: 56px;\n  height: 56px;\n  margin: 0 auto 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  /* Brand tint, not the amber/red of a destructive action: signing out loses\n     no data, so warning colours would overstate it. */\n  background: rgba(109, 93, 246, 0.12);\n  color: var(--accent, #6d5df6);\n}\n\n.logout-confirm-card h3 {\n  margin: 0 0 12px;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.logout-confirm-card p {\n  margin: 0 0 24px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.logout-confirm-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n}\n\n.logout-confirm-actions button {\n  flex: 1;\n  padding: 12px 20px;\n  border-radius: var(--radius-md, 10px);\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;\n}\n\n.logout-confirm-cancel {\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-color);\n}\n\n.logout-confirm-cancel:hover {\n  background: var(--bg-secondary);\n}\n\n/* The MaxelPay button: same violet gradient as .btn-primary. */\n.logout-confirm-submit {\n  background: linear-gradient(135deg, #8b5cf6, #7c3aed);\n  color: #ffffff;\n  border: none;\n}\n\n.logout-confirm-submit:hover {\n  background: linear-gradient(135deg, #7c3aed, #6d28d9);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);\n}\n\n.logout-confirm-actions button:focus-visible {\n  outline: 2px solid var(--accent, #6d5df6);\n  outline-offset: 2px;\n}\n\n@keyframes logout-confirm-fade {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes logout-confirm-rise {\n  from { opacity: 0; transform: translateY(8px) scale(0.98); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n/* Respect a reduced-motion preference: show the dialog, skip the movement. */\n@media (prefers-reduced-motion: reduce) {\n  .logout-confirm-backdrop,\n  .logout-confirm-card {\n    animation: none;\n  }\n  .logout-confirm-submit:hover {\n    transform: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .logout-confirm-card {\n    padding: 24px 20px;\n  }\n  .logout-confirm-actions {\n    flex-direction: column-reverse; /* primary action nearest the thumb */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
